// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610142105/js/" + chunkId + "." + {"44":"e6b1caba","225":"9661450f","481":"07014bcc","486":"abbc54f6","770":"e8f43196"}[chunkId] + ".0.8855403338784358.chunk.js";
};